<template>
  <w-dialog :show="visible"
            confirm
            class="complain"
            show-close
            title="封禁文件申诉"
            :box-style="{width: '428px'}"
            :bodyStyle="{padding: 0}"
            @close="close">
    <div class="complain-wrapper">
      <div class="section flex flex-row">
        <div class="float_left" style="width: 70px;">封禁文件：</div>
        <div style="word-break: break-all;width: 300px;">{{fileInfo.fileName}}</div>
      </div>
      <div class="section reason">
        <h3 class="complain-section-title">封禁原因</h3>
        <div class="complain-reason">
          <ul>
            <li>该文件可能包含如下违禁内容</li>
            <li>1、淫秽色情信息；</li>
            <li>2、血腥暴力信息；</li>
            <li>3、其他违反法律法规的信息</li>
            <li>如需了解更多内容，请阅读<a href="/#/agreement" target="_blank">《用户协议》</a>；</li>
          </ul>
        </div>
      </div>
      <div class="section info">
        <h3 class="complain-section-title">申诉资料填写</h3>
        <div class="complain-info">
          <w-form ref="ruleForm" :model="formData" :rules="rules" label-position="left" label-width="80px">
            <w-form-item label="手机号：" prop="phone">
              <w-input size="small" placeholder="请输入手机号" type="tel" maxlength="11" v-model.trim.number="formData.phone" clearable autofocus></w-input>
            </w-form-item>
            <w-form-item label="验证码：" prop="checkCode">
              <div class="code-box flex flex-row">
                <w-input size="small" placeholder="请输入验证码" v-model.trim="formData.checkCode" clearable></w-input>
                <div class="code-img cursor-pointer" style="width: 84px; padding-left: 8px;height: 32px;">
                  <!--<img src="https://zjytest.glodon.com/backend/common/captcha?type=manual&timer=1607309675626" height="32px">-->
                  <img :src="verificationCodeSrc + this.lockType + '&timer=' + verificationCodeTimer"
                       :key="verificationCodeTimer"
                       @click="refreshVerification()"
                       height="32px"/>
                </div>
              </div>
            </w-form-item>
            <div class="w__form-item">
              <div class="w__form-item__content">
                <w-checkbox v-model="formData.agree">同意审查人员查看我的文件，以及处理我的申诉请求</w-checkbox>
              </div>
            </div>
          </w-form>
        </div>
      </div>
      <div class="text-align-right" style="padding-top: 8px;">
        <w-button size="small" type="primary" :disabled="!formData.agree" @click="submitForm">提交申诉</w-button>
        <w-button size="small" @click.stop.prevent="resetForm">取消</w-button>
      </div>
    </div>
  </w-dialog>
</template>

<script>
import {backendUrl} from '@/assets/js/config'
import messageService from '@/assets/service/message'
import {getCookie} from '@/assets/utils/CommonUtil'

export default {
  name: 'Complain',
  data () {
    const validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      verificationCodeSrc: backendUrl + '/common/captcha?type=',
      lockType: 'appeal',
      verificationCodeTimer: new Date().getTime(), // 二维码时间戳
      formData: {
        phone: '',
        checkCode: '',
        agree: false
      },
      rules: {
        phone: [
          {required: true, validator: validateMobile, trigger: 'blur'}
        ],
        checkCode: [
          {required: true, message: '验证码不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    fileInfo: {
      required: true,
      type: Object,
      default: () => {
        return {
          fileId: '',
          fileName: ''
        }
      }
    }
  },
  watch: {
    visible (value) {
      if (value) {
        this.verificationCodeTimer = Date.now()
        this.formData = {
          phone: '',
          checkCode: '',
          agree: false
        }
      }
    }
  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const {phone, checkCode} = this.formData
          let params = {
            fileId: this.fileInfo.fileId,
            phone,
            checkCode,
            uuid: getCookie('simpleCaptcha_' + this.lockType) // uuid 写在指定域下的 本地获取不到
          }
          messageService.ugcAppeal(params).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.close(true)
            } else {
              // 270002 图形验证码输入错误
              this.$message.error(res.message)
            }
          }).catch((error) => {
            this.loading = false
            this.$message.error(error.message)
          })
        }
      })
    },
    resetForm () {
      this.formData.agree = false
      this.$refs.ruleForm.resetFields()
      this.close()
    },
    // 关闭弹窗
    close (success = false) {
      this.$emit('close', success)
    },
    // 刷新二维码
    refreshVerification () {
      this.verificationCodeTimer = new Date().getTime()
    }
  }
}
</script>

<style lang="less">
  .complain {
    .complain-wrapper {
      padding: 20px 24px 24px 24px;
      .section {
        .complain-section-title {
          padding: 24px 0 12px 0;
          height: 24px;
          line-height: 24px;
          font-size: 16px;
          font-weight: 600;
          color: #212530;
          line-height: 24px;
        }
        .complain-reason {
          height: 110px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(33, 37, 48, 0.8);
          line-height: 22px;
          a {
            color: #2079FA;
          }
        }
        .complain-info {
          padding-top: 8px;
        }
        .w__checkbox__input.is-checked+.w__checkbox__label {
          color: #212530;
        }
      }
    }
  }
</style>
